module.exports = __webpack_public_path__ + "assets/images/2537020e983d52ccf0b6c698a13c20fd.png";